<template>
<div class="dashboard-container scroll-vertical">
  <div class="tile is-ancestor">
    <div class="tile is-vertical">
      <div class="tile">
        <div class="tile is-parent">
          <tile-basic
            class="is-info"
            :values="info"
            :img="img(asset)"
            title="Asset Info"
            :link="infoLink">
          </tile-basic>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child">
            <map-kit-map
              name="asset-location-map"
              :lat="asset.latitude"
              :long="asset.longitude">
            </map-kit-map>
          </div>
        </div>
      </div>

      <div class="tile">
        <div class="tile is-parent">
          <div class="tile is-parent is-danger">
            <div class="tile is-child">
              <chart-line-bar-time-series
                endpoint="primary/listAlertsStats"
                title="Alerts"
                :asset="asset"
                :filter="filter"
                height="150px">
                <p
                  v-for="filt in filters"
                  :key="filt.label"
                  class="level-item is-size-6 filter"
                  :class="{ 'selected': filt.label === filter.label }"
                  @click="filter=filt">
                  {{ filt.label }}
                </p>
              </chart-line-bar-time-series>
              <value-count-tags
                class="value-tags"
                endpoint="primary/listAlertsTags"
                :filter="filter"
                v-on:tag-click="$router.push({
                  name: 'assets.index.detail.alerts',
                  params: { id: asset.uuid },
                  query: { q: [`tag:${$event.tag}`] }
                });"
                :asset="asset"
              ></value-count-tags>
            </div>
            <!-- <div class="tile is-child is-3">
              <chart-pie-value-count
                endpoint="primary/listAlertsTags"
                :asset="asset"
                :filter="filter"
                height="200px"
                width="95%">
              </chart-pie-value-count>
              <h5>Alert Tags</h5>
            </div> -->
          </div>
        </div>
      </div>

      <div class="tile">
        <div class="tile is-parent">
          <div class="tile is-parent is-blue">
            <div class="tile is-child">
              <chart-line-bar-time-series
                endpoint="primary/listLogsStats"
                title="Logs"
                :asset="asset"
                :filter="filter"
                height="auto"
                baseColor:="#348AA7">
                  <p
                    v-for="filt in filters"
                    :key="filt.label"
                    class="level-item is-size-6 filter"
                    :class="{ 'selected': filt.label === filter.label }"
                    @click="filter=filt">
                    {{ filt.label }}
                  </p>
              </chart-line-bar-time-series>
              <value-count-tags
                class="value-tags"
                endpoint="primary/listLogsTags"
                :filter="filter"
                :asset="asset"
                v-on:tag-click="$router.push({
                  name: 'assets.index.detail.logs',
                  params: { id: asset.uuid },
                  query: { q: [`tag:${$event.tag}`] }
                });"
              ></value-count-tags>
            </div>
          </div>
        </div>
        <div class="tile is-parent">
          <tile-profile
            v-if="profile"
            class="is-primary"
            :profile="profile"
            :link="profileLink">
          </tile-profile>
          <tile-basic
            v-else
            class="is-primary empty-profile"
            title="Asset Profile"
            img="profile"
            headerImg="profile">
            <div slot="bottom">
              <router-link
              :to="{ name: 'assets.index.detail.profile', params: { id: asset.uuid } }">
                <vertical-level>
                  <svgicon
                    class="vlevel-item tile-icon"
                    name="profile"
                    width="125"
                    height="125">
                  </svgicon>
                  <p class="vlevel-item">Set a Profile</p>
                </vertical-level>
              </router-link>
            </div>
          </tile-basic>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import assets from '@/mixins/assets';
import timefilters from '@/mixins/timefilters';
import MapKitMap from '@/components/assets/MapKitMap.vue';
import TileBasic from '@/components/TileBasic.vue';
import TileProfile from '@/components/profiles/tiles/TileProfile.vue';
import VerticalLevel from '@/components/VerticalLevel.vue';
import ChartLineBarTimeSeries from '@/components/charts/ChartLineBarTimeSeries.vue';
import ValueCountTags from '@/components/ValueCountTags.vue';

export default {
  name: 'AssetDashboard',
  mixins: [assets, timefilters],
  components: {
    MapKitMap,
    TileBasic,
    TileProfile,
    VerticalLevel,
    ChartLineBarTimeSeries,
    ValueCountTags,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filter: {
        label: '7 Days',
        since: '6 days',
        interval: 'day',
      },
      profile: null,
    };
  },
  async mounted() {
    if (this.asset.profile) {
      this.profile = await this.$store.dispatch('primary/getProfile', { id: this.asset.profile.id });
    }
  },
  computed: {
    info() {
      return this.keyValues(this.asset);
    },
    profileLink() {
      return {
        name: 'assets.index.detail.profile',
        params: { id: this.asset.uuid },
      };
    },
    infoLink() {
      return {
        name: 'assets.index.detail',
        params: { id: this.asset.uuid },
      };
    },
    alertLink() {
      return {
        name: 'assets.index.detail.alerts',
        params: { id: this.asset.uuid },
      };
    },
    logLink() {
      return {
        name: 'assets.index.detail.logs',
        params: { id: this.asset.uuid },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.dashboard-container {
  padding: 1rem 2rem 1rem 1rem;
}

h5 {
  width: 100%;
  text-align: center;
  font-size: 1rem;
}

.empty-profile {
  .vlevel {
    align-items: center;
  }

  p.vlevel-item {
    text-align: center;
    color: whitesmoke;
  }

  svg.svg-fill {
    fill: currentColor;
  }
}

p {
  text-align: center;
  margin-bottom: 0;
}

p.filter {
  padding: .2rem;
  cursor: pointer;
}

p.filter:nth-last-child(2) {
  margin-left: .5rem;
  margin-right: .5rem;
}
</style>
